import HomePage from './HomePage/Home'
import LoginPage from './LoginPage/LoginPage'
import ChallengePage from './ChallengePage/ChallengePage'
import RegistryPage from './RegistryPage/RegistryPage'
import AccountVerificationPage from './AccountVerificationPage/AccountVerificationPage'
import LegalPage from './LegalPage/LegalPage'
import RecoverPasswordPage from './RecoverPasswordPage/RecoverPasswordPage'
import TrainersPage from './TrainersPage/TrainersPage'

export {
	HomePage,
	LoginPage,
	ChallengePage,
	RegistryPage,
	AccountVerificationPage,
	LegalPage,
	RecoverPasswordPage,
	TrainersPage
}



// WEBPACK FOOTER //
// ./src/client/website/pages/index.js